import { CaretLeftFilled } from '@ant-design/icons'
import { ProviderAccount } from '@prisma/client'
import { Button, Flex, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { ProviderClient } from '~/plugins/data-connector/providers/abstract/provider.client'
import { FormClient } from '~/plugins/form/client'
import { InputsForm } from '../InputsForm'

type Props = {
  account?: ProviderAccount
  provider?: ProviderClient
  onSubmit?: (accountUpdated: ProviderAccount) => void
  onSubmitInput?: (values: any) => void
}

export const FormConnect: React.FC<Props> = ({
  account,
  provider,
  onSubmit,
  onSubmitInput,
}) => {
  const [stepIndex, setStepIndex] = useState(1)

  const [accountUpdated, setAccountUpdated] = useState(account)

  const inputs = provider.authentication?.inputs ?? []

  const FormInstance = FormClient.use({
    onSubmit: onSubmitInput,
  })

  const handleNext = (valuesUpdated: ProviderAccount) => {
    setAccountUpdated(valuesUpdated)
    setStepIndex(index => (index += 1))
  }

  const handleSubmit = (valuesUpdated: ProviderAccount) => {
    onSubmit?.(valuesUpdated)
  }

  const handleBack = () => {
    setStepIndex(index => (index -= 1))
  }

  useEffect(() => {
    if (inputs.length > 0) {
      FormInstance.start()
    }
  }, [inputs])

  if (!provider) {
    return (
      <Flex align="center" justify="center" className="w-full">
        <Typography.Text type="secondary">
          No configuration available for this provider
        </Typography.Text>
      </Flex>
    )
  }

  if (inputs.length > 0) {
    return (
      <>
        <FormInstance.FormView isModal={false}>
          <InputsForm inputs={inputs} />
        </FormInstance.FormView>
      </>
    )
  }

  return (
    <Flex vertical className="w-full p-4">
      <provider.FormConnectSteps
        account={accountUpdated}
        provider={provider}
        stepIndex={stepIndex}
        onNext={handleNext}
        onSubmit={handleSubmit}
      />

      {stepIndex > 1 && (
        <Flex>
          <Button icon={<CaretLeftFilled />} type="text" onClick={handleBack}>
            Back
          </Button>
        </Flex>
      )}
    </Flex>
  )
}
